import React from 'react';
import { Button, Spin } from 'antd';
import Close from 'ui-component/icons/close';
import { useStyles, M } from './index.style';

interface IHookProps {
  open: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  hiddenFooter?: boolean;
  title?: any;
  loading?: boolean;
  closable?: boolean;
  maskClosable?: boolean;
  children?: any;
  width?: string | number;
  btnSize?: 'small' | 'middle';
  confirmText?: string;
  hiddenCancel?: boolean;
  noCloseIcon?: boolean;
}

const MModal: React.FC<IHookProps> = ({
  open,
  onCancel,
  onConfirm,
  hiddenFooter = false,
  title = '',
  children,
  loading = false,
  closable = true,
  maskClosable = true,
  width = 520,
  btnSize = 'small',
  confirmText = '确认',
  hiddenCancel,
  noCloseIcon,
}) => {
  const { styles, cx } = useStyles();

  return (
    <M
      title={<div className={styles.title}>{title}</div>}
      closable={closable}
      open={open}
      maskClosable={maskClosable}
      onCancel={onCancel}
      width={width}
      className={noCloseIcon ? styles.noCloseIcon : ''}
      footer={
        !hiddenFooter ? (
          <div key="btn">
            {!hiddenCancel ? (
              <Button loading={loading} onClick={onCancel} className={cx(styles.cancel, btnSize === 'middle' && styles.middle)}>
                取消
              </Button>
            ) : null}

            <Button
              loading={loading}
              type="primary"
              onClick={onConfirm}
              className={cx(styles.confirm, btnSize === 'middle' && styles.middle)}
            >
              {confirmText}
            </Button>
          </div>
        ) : null
      }
      closeIcon={<Close width="28px" height="28px" />}
    >
      <Spin spinning={loading}>{children}</Spin>
    </M>
  );
};

export default MModal;
